import React, { useState } from 'react'
import type { FfpDashboardData, PeriodKey } from '../../types'
import { Engagement } from '../Engagement'
import { Feedback } from '../Feedback'
import { Header } from '../Header'
import { Health } from '../Health'
import { Overview } from '../Overview'
import { Progress } from '../Progress'
import { track } from '@utils/tracking'
import styles from './dashboard.module.sass'
import './tokens.module.sass'

// The page. Its root carries the global ffpDashboard class that every
// module's selectors sit under, so the white-label styles can't repaint it.
// The period lives here: each section slices its own monthly series.
// Incognito (the sales dashboard) swaps the name in the data, so every
// heading and footer below that names the company leaves it out.
const hideName = (data: FfpDashboardData): FfpDashboardData => ({
  ...data,
  organization: { ...data.organization, name: 'Company name hidden' },
})

export const Dashboard = ({ data: loaded, incognito = false }: { data: FfpDashboardData; incognito?: boolean }) => {
  const [period, setPeriod] = useState<PeriodKey>('last_month')
  const data = incognito ? hideName(loaded) : loaded
  const sharedWith = incognito ? 'the company' : data.organization.name

  const onPeriod = (next: PeriodKey) => {
    setPeriod(next)
    track('FFP Dashboard: Change period', { period: next })
  }

  return (
    <div className={`ffpDashboard ${styles.page}`}>
      <div className={styles.inner}>
        <Header data={data} period={period} onPeriod={onPeriod} />
        <section className={styles.overview}>
          <Overview data={data} period={period} />
        </section>
        <Health data={data} period={period} />
        <Progress data={data} period={period} />
        <Engagement data={data} period={period} />
        <Feedback data={data} period={period} />
        <footer className={styles.disclaimer}>
          These figures are for illustration and are not financial advice or a guarantee of future results. They are based on the information your people have
          shared with Wealthbit and on assumptions about returns and inflation. Individual results will differ. No names or personal details are shared with{' '}
          {sharedWith}.
        </footer>
      </div>
    </div>
  )
}
